import { Snackbar, Alert } from "@mui/material";
import { memo } from "react";

const iconMap = {
  success: "✅",
  error: "❌",
  warning: "⚠️",
  info: "ℹ️",
};

function KsbAlert({
  open,
  onClose,
  message,
  severity = "success",
  autoHideDuration = 4000,
  anchorOrigin = { vertical: "bottom", horizontal: "center" },
}) {
  const icon = iconMap[severity] || "";

  return (
    <Snackbar
      open={open}
      autoHideDuration={autoHideDuration}
      onClose={onClose}
      anchorOrigin={anchorOrigin}
    >
      <Alert
        onClose={onClose}
        severity={severity}
        variant="filled"
        sx={{ width: "100%" }}
      >
        {icon} {message}
      </Alert>
    </Snackbar>
  );
}

export default memo(KsbAlert);
